import React from "react";

export default function DetailsBtns({title}) {
  return <div className="journal-box__item grey-box">{title}</div>;
}
